// FAQ Controller
// Auto-opens the <details> entry whose id matches the URL hash, and
// smooth-scrolls to it. Lets us share deep links like
// /help#faq-stripe-payouts that land users directly on the right answer.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.openMatchingHash()
    this.boundHandleHashChange = this.openMatchingHash.bind(this)
    window.addEventListener("hashchange", this.boundHandleHashChange)
  }

  disconnect() {
    window.removeEventListener("hashchange", this.boundHandleHashChange)
  }

  openMatchingHash() {
    const hash = window.location.hash
    if (!hash || hash.length < 2) return

    // Only act on FAQ-style anchors so we don't fight other in-page hashes
    if (!hash.startsWith("#faq-")) return

    const target = document.getElementById(hash.slice(1))
    if (!target || target.tagName !== "DETAILS") return

    target.open = true
    // Scroll after the panel expands so the question stays in view
    setTimeout(() => {
      target.scrollIntoView({ behavior: "smooth", block: "start" })
    }, 50)
  }
}
